import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGlowStandard from "./sections/TheGlowStandard";
import TheGoldStandard from "./sections/TheGoldStandard";
import TheCityRideSpectrum from "./sections/TheCityRideSpectrum";
import ReserveYourRide from "./sections/ReserveYourRide";
import TheExecutiveCollection from "./sections/TheExecutiveCollection";
import Fahrzeuge from "./sections/Fahrzeuge";
import VoicesOfOurGuests from "./sections/VoicesOfOurGuests";
import SpecializedTreatments from "./sections/SpecializedTreatments";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGlowStandard />
      <TheGoldStandard />
      <TheCityRideSpectrum />
      <ReserveYourRide />
      <TheExecutiveCollection />
      <Fahrzeuge />
      <VoicesOfOurGuests />
      <SpecializedTreatments />
      <Footer />
    </div>;
}